import React, { useState, useEffect } from "react";
import "../../../Styles/Modal.css";
import "../../../Styles/reModal.css";
import { ImCancelCircle } from "react-icons/im";


const PaymentModal = ({ handlePaySelect, selPay, handlePayModal }: any) => {


  const [selectedPay, setSelectedPay] = useState("");
  const handlePayClick = (type: any) => {
    setSelectedPay(type);
    handlePaySelect(type);
    // console.log(type);
  };

  return (
    <div className="modal">
      <div className="catModal">
        <div className="catModalTop">
          <h4>Payment Type</h4>
          <ImCancelCircle className="catCancel" onClick={handlePayModal} />
        </div>
        <div className="line"></div>
        <div className="cusmm">
          <p
            onClick={() => handlePayClick("Full Payment")}
            
            className={`${selectedPay === "Full Payment" ? "payT payDark" : "payT"}`}
          >
            Full Payment
          </p>
          {/* <p
            onClick={() => handlePayClick("half")}
            className={`${selectedPay === "half" ? "payT payDark" : "payT"}`}
          >
            Half Payment
          </p> */}
        </div>

        <div className="catModalBtn">
          <button
            className={`${selPay ? "catBtn1" : "opBtn"}`}
            onClick={handlePayModal}
          >
            Select
          </button>
          <button className="catBtn2" onClick={handlePayModal}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
